// removed by extract-text-webpack-plugin
module.exports = {"barTab":"styles__barTab__1o5sN","tabNav":"styles__tabNav__2nLDq","tab":"styles__tab__Lnz-I","tabContent":"styles__tabContent__13qhI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BarTab/styles.scss
// module id = 177
// module chunks = 0